import {Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { FacebookService } from "src/app/services/social/facebook.service";

@Component({
  selector: "app-facebook-post",
  templateUrl: "./facebook-post.component.html",
  styleUrls: ['./facebook-post.component.css']
})
export class FacebookPostComponent implements OnInit, OnDestroy {
  @Output() onRefresh = new EventEmitter<void>();
  post: any = {};
  attachments;
  accountDetails: any = {};
  selectedPost: any = null;
  attachmentType;
  fbComments: any[] = [];
  currentFbSlide = 0;
  pendingDeleteId = null;
  deletingId = null;
  fbCommentsLoading = false;
  submittingComment = false;
  showEmojiPicker = false;
  postLiked = false;
  newCommentText = '';
  replyingToComment: any = null;
  @ViewChild('videoElement') videoElement: ElementRef;
  @ViewChild('fbCommentInputRef') fbCommentInputRef: ElementRef;
  @ViewChild('fbCommentsScroll') fbCommentsScroll: ElementRef;
  emojiList = [
    '😀', '😂', '😍', '😎', '😭', '😤', '😊', '🥰',
    '😅', '😆', '🤣', '😇', '🥳', '😏', '😒', '😓',
    '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍',
    '🔥', '✨', '💯', '🎉', '👏', '🙌', '👍', '👎',
    '😢', '😩', '🤔', '🤩', '😋', '😜', '🤪', '😝',
    '🙏', '💪', '🫶', '👀', '💀', '🫠', '😤', '🥲',
    '🚀', '🌟', '💫', '⚡', '🎯', '💥', '🌈', '🎊',
  ];
  constructor(private facebookService: FacebookService) {
    facebookService.fetchOrganizationPages("").subscribe(
      (response) => {
        const { status_code, success, payload } = response;
        if (success && (status_code == 200 || status_code == 201)) {
          this.accountDetails = payload.active_page || {};
        }
      }
    );
  }

  ngOnInit() {
    this.facebookService.postToView.subscribe((post: any) => {
      if (!post || !Object.keys(post).length) { return; }
      this.post = post.post;
      this.attachments = post.post.attachments;
      this.attachmentType = this.postMediaType(post.post);
      const targetCommentId: string | null = post.post ? (post.commentId || null) : null;
      const targetReplyId: string | null = post.post ? (post.replyId || null) : null;
      const targetParentCommentId: string | null = post.post ? (post.parentCommentId || null) : null;
      this.currentFbSlide = 0;
      this.fbComments = (post.post.comments.data || []).map((c: any) => ({
        ...c,
        liked: c.liked || false,
        showReplies: false,
        comments: c.comments ? {
          ...c.comments,
          data: (c.comments.data || []).map((r: any) => ({
            ...r,
            liked: r.liked || false,
          }))
        } : { data: [] },
      }));
      const modalEl = document.getElementById("facebookPostModal");
      const wasAlreadyOpen = modalEl && modalEl.classList.contains('show');
      this.openPostModal();
      if (wasAlreadyOpen) {
        this._signalModalReady();
      } else {
        let ready = false;
        const onReady = () => {
          if (ready) return;
          ready = true;
          if (modalEl) modalEl.removeEventListener('shown.bs.modal', onReady);
          this._signalModalReady();
        };
        if (modalEl) {
          modalEl.addEventListener('shown.bs.modal', onReady);
          if (!modalEl.classList.contains('show')) {
            modalEl.addEventListener('hidden.bs.modal', () => {
              if (!ready) this.openPostModal();
            }, { once: true });
          }
        }
        setTimeout(onReady, 2000);
      }
      this._refreshVideo();
      if(post.action == 'view-reply') {
        this.newCommentText =""
        this.replyingToComment =null;
        setTimeout(() => this._handleDeepLink(targetCommentId, targetReplyId, targetParentCommentId), 400);
      } else {
        setTimeout(() => this._handleDeepLink(targetCommentId, targetReplyId, targetParentCommentId), 400);
      }
    });
  }
  ngOnDestroy() {
    this.facebookService.postToView.unsubscribe();
  }

  _handleDeepLink(commentId: string | null, replyId: string | null, parentCommentId: string | null) {
    // Determine which comment to auto-reply to
    let targetComment: any = null;
    if (replyId && parentCommentId) {
      // Find parent, expand replies, scroll to reply row, reply to the reply
      targetComment = this.fbComments.find((c: any) => c.id == parentCommentId);
      if (targetComment) {
        targetComment.showReplies = true;
        const targetReply = targetComment.replies.find((r: any) => r.id === replyId);
        if (targetReply) {
          if(this.post.action == 'view-reply') {
            setTimeout(() => {
              this._scrollToItem(replyId);
            }, 150);
            return;
          }
          setTimeout(() => {
            this._scrollToItem(replyId);
            this.replyTo(targetReply);
          }, 150);
        }
      }
      return;
    }

    if (commentId) {
      targetComment = this.fbComments.find((c: any) => c.id === commentId);
      if (targetComment) {
        setTimeout(() => {
          this._scrollToItem(commentId);
          this.replyTo(targetComment);
        }, 150);
      }
    }
  }
  _scrollToItem(id: string) {
    const container = this.fbCommentsScroll.nativeElement;
    if (!container) { return; }

    const el = container.querySelector(`[data-comment-id="${id}"]`);
    if (!el) { return; }

    el.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Brief highlight pulse
    el.classList.add('fb-comment-highlight');
    setTimeout(() => el.classList.remove('fb-comment-highlight'), 1500);
  }
  replyTo(comment: any) {
    this.replyingToComment = comment;
    this.newCommentText = `@${comment.from.name} `;
    // focus input
    setTimeout(() => this.fbCommentInputRef.nativeElement.focus(), 100);
  }
  postMediaType(post) {
    const attachment = post.attachments ? post.attachments.data : [];
    const attachmentType = attachment.length > 0 ? attachment[0].type : "text";
    if (attachmentType === 'video_inline') return 'video';
    if (attachmentType === 'video_direct_response') return 'video';
    if (attachmentType === 'album') return 'photo';
    if (post.full_picture || attachmentType === 'photo') return 'photo';
    return 'text';
  }

  get fbSlides(): any[] {
    const attachments = this.attachments ? this.attachments.data :  [];
    if (attachments.length > 0 && attachments[0].type === 'album' && attachments[0].subattachments.data) {
      return attachments[0].subattachments.data;
    }
    return attachments.length > 1 ? attachments : [];
  }

  openPostModal() {
    const modalEl = document.getElementById("facebookPostModal");
    if (!modalEl) return;

    if (modalEl.classList.contains('show')) return;

    const btn = document.getElementById("facebookPostModalBtn");
    if (btn) btn.click();
  }

  prevFbSlide() {
    if (this.currentFbSlide > 0) {
      this.currentFbSlide--;
    }
  }

  nextFbSlide() {
    const slides = this.fbSlides;
    if (this.currentFbSlide < slides.length - 1) {
      this.currentFbSlide++;
    }
  }

  gotoFbSlide(index: number) {
    this.currentFbSlide = index;
  }

  get fbCurrentMediaUrl(): string {
    const slides = this.fbSlides;
    if (slides.length > 0) {
      const current = slides[this.currentFbSlide];
      return current.media.image.src || current.media.source || this.post.full_picture;
    }
    return this.post.full_picture;
  }

  private _signalModalReady() {
    this.facebookService.postModalReady$.next();
  }

  private _refreshVideo() {
    setTimeout(() => {
      if (this.attachmentType === 'video' && this.videoElement && this.videoElement.nativeElement) {
        this.videoElement.nativeElement.load();
      }
    });
  }

  onCloseModal() {
    if (this.videoElement && this.videoElement.nativeElement) {
      this.videoElement.nativeElement.pause();
      this.videoElement.nativeElement.removeAttribute('src');
      this.videoElement.nativeElement.load();
      this.videoElement.nativeElement.currentTime = 0;
    }

    this.post = {};
    this.attachments = null;
    this.attachmentType = null;
    this.currentFbSlide = 0;
    this.newCommentText = '';
    this.replyingToComment = null;
  }
  toggleEmojiPicker(event) {
    event.stopPropagation();
    this.showEmojiPicker = !this.showEmojiPicker;
  }
  selectEmoji(emoji: string) {
    this.newCommentText = (this.newCommentText || '') + emoji;
    this.showEmojiPicker = false;
    setTimeout(() => this.fbCommentInputRef.nativeElement.focus(), 50);
  }

  submitFbComment() {
    const text = this.newCommentText.trim();
    if (!text || this.submittingComment) return;
    this.submittingComment = true;
    if (this.replyingToComment) {
      this.facebookService.replyComment({ commentId: this.replyingToComment.id, message: text}).subscribe({
        next: (res: any) => {
          if (!this.replyingToComment.comments) this.replyingToComment.comments = { data: [] };
          this.replyingToComment.comments.data.push({
            id: res.payload.id || Date.now(),
            message: text,
            from: { name: this.accountDetails.name , id: this.accountDetails.id},
            created_time: new Date().toISOString(),
          });
          this.replyingToComment.showReplies = true;
          this.replyingToComment = null;
          this.newCommentText = '';
          this.onRefresh.emit();
          this.scrollFbToBottom();
          this.submittingComment = false;
        },
        error: (err) => {
          this.submittingComment = false;
        }
      });
    } else {
      this.facebookService.replyPost({ postId: this.post.id, message: text}).subscribe({
        next: (res: any) => {
          this.fbComments.push({
            id: res.payload.id || Date.now(),
            message: text,
            from: { name: this.accountDetails.name , id: this.accountDetails.id},
            created_time: new Date().toISOString(),
            liked: false,
            showReplies: false,
            replies: [],
          });
          this.newCommentText = '';
          this.onRefresh.emit();
          this.scrollFbToBottom();
          this.submittingComment = false;
        },
        error: (err) => {
          this.submittingComment = false;
        }
      });
    }
  }

  replyToFb(comment: any) {
    this.replyingToComment = comment;
    setTimeout(() => this.fbCommentInputRef.nativeElement.focus(), 100);
  }

  cancelFbReply() {
    this.replyingToComment = null;
    this.newCommentText = '';
  }
  confirmDelete(id: string): void {
    this.pendingDeleteId = id;
  }
  cancelDelete() {
    this.pendingDeleteId = null;
  }
  canDelete(media: any) {
    return media.from ? media.from.name == this.accountDetails.name : false;
  }
  deleteFbComment(comment: any) {
    this.deletingId = comment.id;
    this.facebookService.deleteComment(comment.id).subscribe({
      next: () => {
        this.fbComments = this.fbComments.filter((c: any) => c.id !== comment.id);
        this.deletingId = null;
        this.pendingDeleteId = null;
        this.onRefresh.emit();
      },
      error: (err) => {
        console.error('delete failed', err);
        this.deletingId = null;
        this.pendingDeleteId = null;
      }
    });
  }

  deleteFbReply(parentId: string, reply: any) {
    this.deletingId = reply.id;
    this.facebookService.deleteComment(reply.id).subscribe({
      next: () => {
        const parent = this.fbComments.find((c: any) => c.id === parentId);
        if (parent && parent.comments.data) {
          parent.comments.data = parent.comments.data.filter((r: any) => r.id !== reply.id);
        }
        this.deletingId = null;
        this.pendingDeleteId = null;
        this.onRefresh.emit();
      },
      error: (err) => {
        this.deletingId = null;
        this.pendingDeleteId = null;
      }
    });
  }

  toggleLikeComment(comment: any) {
    const prevLiked = comment.liked;
    const prevCount = comment.like_count || 0;
    comment.liked = !comment.liked;
    comment.like_count = comment.liked ? prevCount + 1 : Math.max(0, prevCount - 1);
    const api = comment.liked
      ? this.facebookService.likeComment(comment.id)
      : this.facebookService.unlikeComment(comment.id);
    api.subscribe({
      error: () => {
        comment.liked = prevLiked;
        comment.like_count = prevCount;
      }
    });
  }

  toggleLikeReply(comment: any, reply: any) {
    const prevLiked = reply.liked;
    const prevCount = reply.like_count || 0;
    reply.liked = !reply.liked;
    reply.like_count = reply.liked ? prevCount + 1 : Math.max(0, prevCount - 1);
    const api = reply.liked
      ? this.facebookService.likeComment(reply.id)
      : this.facebookService.unlikeComment(reply.id);
    api.subscribe({
      error: () => {
        reply.liked = prevLiked;
        reply.like_count = prevCount;
      }
    });
  }

  getInitials(username: string): string {
    if (!username) {
      return 'FB';
    }
    return username.slice(0, 2).toUpperCase();
  }

  scrollFbToBottom() {
    setTimeout(() => {
      const el = this.fbCommentsScroll.nativeElement;
      if (el) el.scrollTop = el.scrollHeight;
    }, 50);
  }

  timeAgo(timestamp: string): string {
    const now = new Date();
    const date = new Date(timestamp);
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (seconds < 60) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days === 1) return 'Yesterday';
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  }
  formatDiv(text: string){
    if (!text) return '';
    return text.replace(/\n/g, '<br>');
  }
}
